// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.67
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-27T12:13:33.634978+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validation the discharge for an encounter
 * @see #/components/schemas/DischargeRequest - reference to schema in open-api-spec.yaml
 * @since 2024-11-27T12:13:33.634978+02:00[Europe/Kiev]
 * @version 1.6.67
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface DischargeRequest {
    /**
     * Discharge reason id.
     * @dataFormat uuid
     */
    discharge_reason?: string;
    /**
     * Discharge reason.
     *
     */
    custom_text?: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for DischargeRequest
 */
export namespace DischargeRequest {
    /**
     * DischargeRequest Frontend Model with camelCase properties
     * @since 2024-11-27T12:13:33.634978+02:00[Europe/Kiev]
     * @version 1.6.67
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Discharge reason id.
         * @dataFormat uuid
         */
        dischargeReason?: string;
        /**
         * Discharge reason.
         * @type string (`dataFormat` is missing)
         */
        customText?: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * DischargeRequest DTO
     * Transforms DischargeRequest model from/to API object
     * @since 2024-11-27T12:13:33.634978+02:00[Europe/Kiev]
     * @version 1.6.67
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend DischargeRequest model */
        static toModel(obj: DischargeRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend DischargeRequest model */
        static toApi(obj: Model): DischargeRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as DischargeRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
